import { captureScreen } from '../../../../javascript/screenshotCapture';
import { emit } from '../../../embed/utils/extensionMessenger';
import getScreenshotPolyfill from '../../../../javascript/screenshotCapture/screenshotPolyfill';

export const captureScreenshot = async ({
  taskMobileScreenshot,
  backgroundColor,
  callback,
  extensionExists,
  basicAuthPresent,
  projectDetailsUrl,
  userId,
  organizationId,
  absoluteDomScreenshotsEnabled
}: {
  taskMobileScreenshot: boolean;
  backgroundColor: string;
  callback: (value: any) => any;
  extensionExists: boolean;
  basicAuthPresent: boolean;
  projectDetailsUrl: string;
  userId?: number;
  organizationId: number;
  absoluteDomScreenshotsEnabled: boolean;
}) => {
  captureScreen({
    screenShotServerAccess: taskMobileScreenshot,
    beforeScreenshot: () =>
      new Promise((resolve, reject) => {
        return resolve(true);
      }),
    afterScreenshot: () => {},
    requestScreenshotDataURI: (opts, onSuccess, onFailure) => {
      if (!extensionExists) {
        onFailure();
        return;
      }

      const token = 'x' + Math.random();

      opts = {
        ...opts,
        extension: 'jpeg',
        quality: 85,
        domainURL: '123',
        backgroundColor,
        projectId: '1',
        token
      };

      emit(
        {
          eventName: 'bugherdScreenshotDataURI',
          eventData: opts,
          responseEventName: 'bugherdScreenshotDataURIResponse'
        },
        response => {
          if (response.token === token) {
            onSuccess(response);
          }
        }
      );
    },
    screenshotPolyfill: () =>
      getScreenshotPolyfill({
        _window: window,
        _document: document,
        basicAuthPresent: basicAuthPresent,
        projectDetailsUrl: projectDetailsUrl,
        _visualViewport: window.visualViewport,
        afterScreenshot: () => {},
        userId,
        organizationId,
        absoluteDomScreenshotsEnabled
      }),
    extensionExists: () => Promise.resolve(extensionExists)
  })
    .then(callback)
    .catch(function(failure) {
      if (window.bugsnagClient) {
        window.bugsnagClient.notify(
          'Screenshot capture failed with failure: ',
          failure
        );
      } else {
        console.error(failure);
      }
    });
};
